<div class="member-details-container" fxLayout="row" fxLayoutGap="30px" xmlns="http://www.w3.org/1999/html"
     xmlns="http://www.w3.org/1999/html">
    <div fxLayout="column" class="pod-panel" fxFlex="25" fxLayoutGap="24px">
        <div class="field-title" fxFlex="10">{{'Assigned communities'|i18n}}</div>
        <div fxLayout="column" fxLayoutAlign="space-around center" fxFlex="90">
            <div fxLayout="column" fxLayoutAlign="space-around center">
                <div *ngFor="let id of member.network_ids">
                    <button app-small-ghost-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                            (click)="openRemoveCommunityDialog(id)" class="grey-btn mb-12"
                            [disabled]="!canUpdate">
                        <div class="field-comm">{{getCommunityFrom(id)}}</div>
                        <div class="grey-box">
                            <app-icon class="no-margin grey-icon" name="fal-times"></app-icon>
                        </div>
                    </button>
                </div>
                <div *ngIf="member.network_ids.length === 0" class="field-comm">
                    {{'No communities assigned'|i18n}}
                </div>
            </div>
            <button app-ghost-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                    class="mt-20 mb-12" (click)="openAssignCommsDialog(member)"
                    [disabled]="!canUpdate || isEditDisabled">
                <app-icon name="fal-plus-circle"></app-icon>
                <div [ngClass]="{'invisible': isEditDisabled}">{{'Manage communities\' assignments'|i18n}}</div>
                <mat-spinner *ngIf="isEditDisabled" diameter="20" class="absolute"></mat-spinner>
            </button>
        </div>
    </div>
    <div fxLayout="column" *ngIf="!!account" class="pod-panel" fxFlex="45">
        <div class="field-title">{{'Account management'|i18n}}</div>
        <div fxLayout="column" fxLayoutGap="32px" class="mt-40 ml-16">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <span class="field-name">{{'Email'|i18n}}:</span>
                <span>{{member.personal_data.email}}</span>
                <button app-small-ghost-button (click)="contactEmail(member.personal_data.email)">
                    <app-icon name="fal-envelope"></app-icon>
                    {{'Contact representative'|i18n}}
                </button>
            </div>
            <div *ngIf="account.enabled" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <div class="field-name">{{'User account status'|i18n}}:</div>
                <div class="field-text">{{'Enabled'|i18n}}</div>
                <button app-small-ghost-button (click)="onClickDisableAccount()"
                        [disabled]="!canUpdate">
                    <app-icon name="fal-user-slash"></app-icon>
                    {{'Disable representative'|i18n}}
                </button>
            </div>
            <div *ngIf="!account.enabled" fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="row" fxLayoutAlign="center center"
                     fxLayoutGap="20px" class="warning-panel">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <app-icon name="fas-info-circle" class="warning-icon"></app-icon>
                    </div>
                    <div>{{mkDisableReasonMessage(account.disableReason)|i18n}}</div>
                    <button app-small-ghost-button (click)="onClickReactivateAccount()"
                            [disabled]="!canUpdate">
                        <app-icon name="fal-user-check"></app-icon>
                        <span>{{'Re-enable representative'|i18n}}</span>
                    </button>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <span class="field-name">{{'Last access on'|i18n}}:</span>
                <span class="field-text">{{isDefined(account.lastAccessOn) ? (account.lastAccessOn|i18nDate) : '--/--/--'}}</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                    <app-icon *ngIf="isPasswordOk(account)" name="fal-check-circle"
                              class="tick-icon"></app-icon>
                    <app-icon *ngIf="!isPasswordOk(account)" name="fal-times" class="cross-icon"></app-icon>
                    <div class="field-text">{{'Regular password status'|i18n}}</div>
                </div>
                <div class="ml-16">
                    <span class="field-name">{{'PW expiration'|i18n}}</span>:
                    <span class="field-text">{{account.pwExpiresOn|i18nDate}}</span>
                </div>
                <button app-small-ghost-button [title]="'Force password change'|i18n" class="ml-16"
                        [disabled]="!canRenewPassword"
                        (click)="onClickForcePwdChange()">
                    <app-icon name="fal-sync-alt"></app-icon>
                    {{'Force PW change'|i18n}}
                </button>
            </div>
            <div *ngIf="show2fa" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <app-icon *ngIf="account.mandatory2fa" name="fal-check-circle" class="tick-icon"></app-icon>
                <app-icon *ngIf="!account.mandatory2fa" name="fal-times" class="cross-icon"></app-icon>
                <div class="field-text">{{'2FA mandatory'|i18n}}</div>
            </div>
            <div *ngIf="show2fa" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <app-icon *ngIf="account.enabled2fa" name="fal-check-circle" class="tick-icon"></app-icon>
                <app-icon *ngIf="!account.enabled2fa" name="fal-times" class="cross-icon"></app-icon>
                <div class="field-text">{{'2FA in use'|i18n}}</div>
                <button app-small-ghost-button [title]="'Reset 2FA'|i18n" class="ml-30"
                        [disabled]="!canReset2FA"
                        (click)="onClickReset2FA()">
                    <app-icon name="fal-shield-alt"></app-icon>
                    {{'Reset 2FA'|i18n}}
                </button>
            </div>
        </div>
        <div class="mt-12"></div>
    </div>
    <div fxLayout="column" *ngIf="member" class="pod-panel" fxFlex="30">
        <div class="field-title">{{'Other informations'|i18n}}</div>
        <div fxLayout="column" fxLayoutGap="40px" class="mt-40 ml-16">
            <div>
                <div class="field-name" fxFlex="30">{{'Representative type'|i18n}}:</div>
                <div class="field-text" fxFlex="70">{{member.representative_type|genericPipe}}</div>
            </div>
            <div *ngIf="mkAddress() as address">
                <div class="field-name" fxFlex="30">{{'Address'|i18n}}:</div>
                <div class="field-text" fxFlex="70">{{address}}</div>
            </div>
            <div *ngIf="member.personal_data?.mobile_number as mobile">
                <div class="field-name" fxFlex="30">{{'Mobile'|i18n}}:</div>
                <div class="field-text" fxFlex="70">{{mobile}}</div>
            </div>
            <div *ngIf="member.personal_data?.telephone_number as phone">
                <div class="field-name" fxFlex="30">{{'Telephone'|i18n}}:</div>
                <div class="field-text" fxFlex="70">{{phone}}</div>
            </div>
            <div *ngIf="member.personal_data?.pec as pec">
                <div class="field-name" fxFlex="30">{{'PEC'|i18n}}:</div>
                <div class="field-text" fxFlex="70">{{pec}}</div>
                <!--    <a [href]="'mailto:'+pec" class="email-anchor">-->
                <!--        <button app-small-ghost-button>-->
                <!--            <app-icon name="fal-envelope"></app-icon>-->
                <!--            {{'Contact member'|i18n}}-->
                <!--        </button>-->
                <!--    </a>-->
            </div>
            <div *ngIf="member.personal_data?.piva as piva">
                <div class="field-name" fxFlex="30">{{'P.IVA'|i18n}}:</div>
                <div class="field-text" fxFlex="70">{{piva}}</div>
            </div>
            <div *ngIf="member.personal_data?.cf as cf">
                <div class="field-name" fxFlex="30">{{'C. F.'|i18n}}:</div>
                <div class="field-text" fxFlex="70">{{cf}}</div>
            </div>
        </div>
        <div class="mt-12"></div>
    </div>
</div>

<ng-template #assignCommunities let-data>
    <div class="assign-container">
        <div fxLayoutAlign="end">
            <button mat-icon-button [mat-dialog-close]="false">
                <app-icon name="fal-times"></app-icon>
            </button>
        </div>
        <div class="data-assign-container">
            <div class="main-title mt-32">
                {{'Assign communities to {0}'|i18n:getNameFrom(member.personal_data)}}
            </div>
            <div fxLayout="column" fxLayoutGap="24px" class="form mt-32">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">
                    <div fxFlex="30">{{'Select one or more communities'|i18n}}:</div>
                    <div fxFlex="60" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">
                        <mat-form-field class="more-width">
                            <mat-label>
                                {{'Communities'|i18n}}
                            </mat-label>
                            <input type="text"
                                   placeholder="{{communitiesPool.length > 0 ? ('Select community'|i18n) : ('No communities available'|i18n)}}"
                                   aria-label="Number" matInput [spellcheck]="false"
                                   [formControl]="commPoolFilter" [matAutocomplete]="auto">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let comm of arrSelectableComms | keyvalue:sortByName"
                                            [value]="comm.value.name"
                                            (onSelectionChange)="onSelectCommunity($event)">
                                    {{comm.value.name}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <button app-primary-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                                [disabled]="!tempC" (click)="onAddCommunity()">
                            <span>{{'Add community'|i18n}}</span>
                        </button>
                    </div>
                </div>
                <div *ngIf="assignations.length > 0" fxLayout="row wrap" fxLayoutAlign="center" fxLayoutGap="12px">
                    <div *ngFor="let ass of assignations">
                        <button app-small-ghost-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                                (click)="removeAssignation(ass)" class="grey-btn mb-12">
                            <span>{{ass.name}}</span>
                            <div class="grey-box">
                                <app-icon class="no-margin grey-icon" name="fal-times"></app-icon>
                            </div>
                        </button>
                    </div>
                </div>
                <div *ngIf="assignations.length === 0" fxLayout="row" fxLayoutAlign="center">
                    <div class="grey-text">{{'No communities assigned'|i18n}}.</div>
                </div>
            </div>
            <div fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="mt-48">
                <button app-primary-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                        [mat-dialog-close]="true">
                    <app-icon name="fal-save"></app-icon>
                    <span>{{'Save assignments'|i18n}}</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #removeCommunity let-data>
    <div class="remove-container">
        <div fxLayoutAlign="end">
            <button mat-icon-button [mat-dialog-close]="false">
                <app-icon name="fal-times"></app-icon>
            </button>
        </div>
        <div class="remove-data-container" fxLayout="column" fxLayoutGap="64px">
            <div class="main-title mt-32" fxLayoutAlign="center center">
                {{'Remove assignation'|i18n}}
            </div>
            <div fxLayoutAlign="center center">
                {{'Are you sure you want to remove {0} from the communities assigned to {1}?'|i18n:data.community.name:getNameFrom(member.personal_data)}}
            </div>
            <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="24px">
                <button app-ghost-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                        [mat-dialog-close]="false">
                    <span>{{'No, cancel'|i18n}}</span>
                </button>
                <button app-primary-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                        [mat-dialog-close]="true">
                    <span>{{'Yes, proceed'|i18n}}</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>
